import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'
import { buildUploadChip, addRemoveButton } from '../lib/upload_chip'

// console.log('done uploading', uploadData)
// // post(this.endpoint, {
// //   body: JSON.stringify(uploadData),
// //   contentType: 'application/json',
// //   responseKind: 'json',
// // }).then(() => {
// //   // Remove the upload element after successful upload
// //   const uploadElement = document.querySelector(`#upload_${this.directUpload.id}`);
// //   if (uploadElement) {
// //     uploadElement.remove();
// //   }
// // }).catch((error) => {
// //   console.error('Upload failed:', error);
// //   // Optionally, update the UI to show the error
// // });

export default class extends Controller {
  boundNewCompletedUpload = this.newCompletedUpload.bind(this)

  connect() {
    this.completedUploads = []
    console.log('connected completed event uploads controller', this.completedUploads)
    this.element.addEventListener("new_completed_upload", this.boundNewCompletedUpload);
  }

  disconnect() {
    this.element.removeEventListener("new_completed_upload", this.boundNewCompletedUpload)
  }

  newCompletedUpload(e) {
    console.log('new completed upload', e.detail)
    
    // Add to the array
    this.completedUploads.push(e.detail)

    const uploadsDataField = document.querySelector("#event_uploads_data");
    if (uploadsDataField) {
      uploadsDataField.value = JSON.stringify(this.completedUploads);
      console.log(JSON.stringify(this.completedUploads))
    }
    
    // The same pill the upload was filling, now settled and holding a remove
    // control. It used to become a differently-shaped green badge on landing,
    // so a file changed shape at the moment it succeeded.
    const uploadId = `upload_${e.detail.signed_blob_id.substring(0, 8)}`
    const chip = buildUploadChip({
      id: uploadId,
      filename: e.detail.filename,
      byteSize: e.detail.byte_size,
      state: 'attached'
    })
    chip.dataset.blobId = e.detail.signed_blob_id

    addRemoveButton(chip, () => this.removeUpload(uploadId, e.detail.signed_blob_id))

    const hiddenInput = document.createElement('input')
    hiddenInput.type = 'hidden'
    hiddenInput.name = 'event[uploads][]'
    hiddenInput.value = e.detail.signed_blob_id
    chip.appendChild(hiddenInput)

    this.element.appendChild(chip)

    // focus at the end of #paperwork_event_message
    const paperworkEventMessage = document.querySelector("#paperwork_event_message");
    if (paperworkEventMessage) {
      paperworkEventMessage.focus();
    }
  }
  
  removeUpload(uploadId, blobId) {
    // Remove from DOM
    const uploadElement = document.getElementById(uploadId)
    if (uploadElement) {
      uploadElement.remove()
    }
    
    // Remove from array
    this.completedUploads = this.completedUploads.filter(
      upload => upload.signed_blob_id !== blobId
    )

    // Update the hidden input field
    const uploadsDataField = document.querySelector("#event_uploads_data");
    if (uploadsDataField) {
      uploadsDataField.value = JSON.stringify(this.completedUploads);
    }
  }
}
